import React from 'react'
import cx from 'classnames'

import { ButtonBase } from 'components/inputs'


export type ExpressCheckoutButtonProps = {
  className?: string
  id?: string
  loading?: boolean
  disabled?: boolean
  onClick?: () => void
  'data-testid': string
}

const ExpressCheckoutButton: React.CFC<ExpressCheckoutButtonProps> = (props) => {
  const { children, className, id, loading, disabled, onClick, 'data-testid': dataTestId } = props

  return (
    <ButtonBase
      className={cx(className, 'border-solid-gray-50 h-56 w-full rounded bg-white', disabled && 'opacity-50')}
      id={id}
      loading={loading}
      disabled={disabled}
      onClick={onClick}
      data-testid={dataTestId}
    >
      {children}
    </ButtonBase>
  )
}


export default ExpressCheckoutButton
